import { useCallback, useState } from "react";
import { ReferralVendor, ReferralVendorModel, UserClient } from "../../GraphQL.User";
import { useLayoutContext } from "../../layout/Layout";
import { toDictionary } from "../../shared/ArrayHelper";
import { useEffectAsync } from "../../shared/useEffectAsync";
import { useGraphQL } from "../../shared/useGraphQL";
import Friendbuy from "./vendors/friendbuy/friendbuy";

export default function ReferralVendorInitializer() {
    const client = useGraphQL(UserClient);
    const { model: layoutModel } = useLayoutContext();
    const [model, setModel] = useState<ReferralVendorModel>();

    useEffectAsync(async () => {
        if (layoutModel === undefined || !layoutModel.isLoggedIn)
            return;

        const response = await client.getReferralVendorModel();
        setModel(response?.data?.getReferralVendorModel);
    }, [client, layoutModel?.isLoggedIn]);

    const renderReferralVendor = useCallback(() => {
        switch (model?.vendor) {
            case ReferralVendor.FriendBuy:
                const options = toDictionary(model?.options ?? []);
                return <Friendbuy
                    merchantId={options["MerchantId"]}
                    email={options["Email"]}
                    authString={options["AuthString"]}
                    signature={options["Signature"]} />
            case ReferralVendor.None:
            default:
                return null;
        }
    }, [model?.options, model?.vendor]);
     
    return renderReferralVendor();
};